import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import gCard from "@/components/g-card/g-card.vue";
import gSteps from "@/components/g-steps/g-steps.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import ComponenteViewModel from "@/shared/view-models/ComponenteViewModel";
import ComponenteController from "@/shared/controllers/componente/componenteController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import OrcamentoComponenteController from "@/shared/controllers/orcamentoComponente/orcamentoComponenteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ProdutoController from "@/shared/controllers/produto/produtoController"

const name = "CompProdutoRepeticao";
export default {
  name,

  components: {
    "g-card": gCard,
    "g-form": gForm,
    "g-button": gButton,
    "g-steps": gSteps,
    gDataTable,
  },

  props: {},

  mounted() {
    OrcamentoController.VerificaSeOrcamentoTemQuantidade(this.$route.params.id).requisicao
    .then((response) => {
      if(response.data.data == false){
        this.$toast.add({severity:'error', detail:'Erro ao Salvar Quantidade. Por favor tente novamente.', life: 5000})
        this.$router.push(`/produto-repeticao/${this.$route.params.id}/info-basicas-repeticao`)
      }
    })
    this.ImagemEmpresa();
    this.getOrcamentobyId();
    var OrcamentoId = this.$route.params.id;
    this.OrcamentoSelecionado = OrcamentoId;
    // this.getComponentesByProdutoIdSelecionado();
    this.getComponetesByOrcamentoId()
    this.SistemaArray             = OrcamentoComponenteController.getEnumDescricaoSistema().SistemaArray
    this.ProdutoSistemaOpcoes     = ProdutoController.GetProdutoByTableSistema().ProdutoOpcoesProdutoNumero
    EmpresaController.getAllEmpresa().requisicao
    .then((Response) => {
      this.UnidadeArray = Response.data.data
    })
  },

  updated() {},

  data() {
    return {
      popupCancelaOrc: false,
      novoComponente: new ComponenteViewModel(),
      popupadicionarcomponente: false,
      copiaOrcamentoQuantidade: false,
      reorcamento: false,
      visibleRight: false,
      SistemaArray: [],
      ProdutoSistemaOpcoes: [],
      SistemaSelecionado: null,
      imagemEmpresa: '',
      colunasProduto: [
        { field: "numeroComponente", header: "Número",  },
        { field: "componenteTipoTexto", header: "Componentes" },
        { field: "ColunaMedidas", header: "Medidas",  },
        { field: "quantidadeCoresFrente", header: "Cor Frente",  },
        { field: "quantidadeCoresVerso", header: "Cor Verso",  },
        {
          field: "descricaoAcabamentoFrenteTexto",
          header: "Acabamento Frente",

        },
        {
          field: "descricaoAcabamentoVersoTexto",
          header: "Acabamento Verso",

        },
        { field: "descricaoMaterialTexto", header: "Material",  },
        {
          field: "descricaoCapaExternaTexto",
          header: "Capa Externa",

        },
        {
          field: "numeroGramaturaCapaExterna",
          header: "Gramatura",

        },
        {
          field: "descricaoPapelOndaTexto",
          header: "Papel Onda",

        },
        {
          field: "numeroGramaturaPapelOnda",
          header: "Gramatura",

        },
        {
          field: "descricaoCapaInternaTexto",
          header: "Capa Interna",

        },
        {
          field: "numeroGramaturaCapaInterna",
          header: "Gramatura",

        },
        { field: "descricaoOndaTexto", header: "Onda" },
        { field: "codigoSistema", header: "Sistema", width: "8%" },
      ],

      key: 0,
      informacao: [],

      Filtro: {
        global: { value: null, matchMode: this.filtros.CONTAINS }, //permite buscar por colunas específicas
        year: { value: null, matchMode: this.filtros.CONTAINS },
        brand: { value: null, matchMode: this.filtros.CONTAINS },
      },
    };
  },

  methods: {
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-repeticao-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `//${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    abrePopupVisualizacao(dadosComponente){
      this.novoComponente = dadosComponente;
      this.novoComponente = this.trocarChaveObjetoParaMaiusculo(dadosComponente)
      this.popupadicionarcomponente = true;
      this.SistemaSelecionado = this.novoComponente.DescricaoSistema
      this.UnidadeSelecionadaSistema = this.novoComponente.EmpresaId;
      this.novoComponente.SistemaTexto = this.SistemaArray.filter(e => e.value === this.SistemaSelecionado)[0].text;
      this.SistemaId = this.novoComponente.SistemaId

    },
    trocarChaveObjetoParaMaiusculo(obj){
      Object.keys(obj).forEach(chave => {
        let chaveNova = ()=>{
          return `${chave[0].toUpperCase() + chave.slice(1,chave.length)}`
        }
        obj[chaveNova()] = obj[chave]
        delete obj[chave]
       })
       return obj
    },
    step5() {
      this.$router.push(
        `/produto-repeticao/${this.$route.params.id}/caracteristicas-produto-repeticao`
      );
    },
    voltarstep3() {
      this.$router.push(
        `/produto-repeticao/${this.$route.params.id}/info-basicas-repeticao`
      );
    },

    getComponetesByOrcamentoId(){
      this.$isLoading(true)
      ComponenteController.getComponentesByOrcamentoId(this.$route.params.id).requisicao
      .then((Response)=>{
        Response.data.data.forEach((obj)=>{
          this.informacao.push(obj)
        })
        this.informacao.forEach((r)=>{
        r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x ${r.numeroAltura} x ${r.numeroAlturaTampa}`
        r.quantidadeCoresFrente = r.quantidadeCoresFrente ? `${r.quantidadeCoresFrente} CORES` : 'SEM IMPRESSÃO'
        r.quantidadeCoresVerso = r.quantidadeCoresVerso ? `${r.quantidadeCoresVerso} CORES` : 'SEM IMPRESSÃO'
        r.codigoSistema = 'Escolha conforme tabela'

        })

          this.key++;
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },

    getComponentesByProdutoIdSelecionado() {
      setTimeout(() => {
        this.axios({
          method: "get",
          url:
            process.env.VUE_APP_WEB_API +
            `Componente/GetComponentesByProdutoIdOrcamentoId/${this.OrcamentoSelecionado}`,
        })
        .then((Response)=>{
          Response.data.data.forEach((obj)=>{
            this.informacao.push(obj)
          })
          this.informacao.forEach((r)=>{
          r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x ${r.numeroAltura} x ${r.numeroAlturaTampa}`
          r.quantidadeCoresFrente = r.quantidadeCoresFrente ? `${r.quantidadeCoresFrente} CORES` : 'SEM IMPRESSÃO'
          r.quantidadeCoresVerso = r.quantidadeCoresVerso ? `${r.quantidadeCoresVerso} CORES` : 'SEM IMPRESSÃO'
          r.codigoSistema = 'Escolha conforme tabela'

          })

            this.key++;
          })
          .catch(() => {});
      }, 200);
    },

    getOrcamentobyId() {
      let OrcamentoId = this.$route.params.id;
      let retorno = this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetOrcamentoById/Get/${OrcamentoId}`,
      }).then((response) => {
        this.reorcamento = response.data.data.reorcamento;
        this.copiaOrcamentoQuantidade =
          response.data.data.copiaOrcamentoQuantidade;
      });
      return retorno;
    },
  },

  computed: {
    TipoComponenteArray(){
      return [this.novoComponente.ComponenteTipoTexto]
    },
    MedidaConformeArray(){
      return [this.novoComponente.DescricaoMedidasTexto]
    },
    CorFrenteArray(){
      return [this.novoComponente.DescricaoCoresFrenteTexto]
    },
    CorVersoArray(){
      return [this.novoComponente.DescricaoCoresVersoTexto]
    },
    CorFrenteAcabamentoArray(){
      return [this.novoComponente.DescricaoAcabamentoFrenteTexto]
    },
    CorVersoAcabamentoArray(){
      return [this.novoComponente.DescricaoAcabamentoVersoTexto]
    },
    CapaInternaArray(){
      return [this.novoComponente.DescricaoCapaInternaTexto]
    },
    CapaExternaArray(){
      return [this.novoComponente.DescricaoCapaExternaTexto]
    },
    MaterialArray(){
      return [this.novoComponente.DescricaoMaterialTexto]
    },
    PapelOndaArray(){
      return [this.novoComponente.DescricaoPapelOndaTexto]
    },
    OndaArray(){
      return [this.novoComponente.DescricaoOndaTexto]
    },
    // SistemaArray(){
    //   return [this.novoComponente]
    // },
    // UnidadeArray(){
    //   return [this.novoComponente]
    // },
  },
};
